import { css as _css } from "@emotion/core";
var _excluded = ["type"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { withMedia } from 'react-media-query-hoc';
import { BedIcon, BathIcon, ParkingIcon, DevelopmentIcon, LeisureIcon, IndustrialIcon, OfficeIcon, RetailIcon, BuildingIcon, DevelopmentSizeIcon, EerIcon } from '@domain-group/fe-co-icon';
import { ListingType, PropertyType } from '@domain-group/fe-allhomes-library';
import * as styles from './features.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DEFAULT_PROPERTY_ICON = BuildingIcon;
var SizeIcon = DevelopmentSizeIcon;
var Icons = {
  [PropertyType.COMMERCIAL_LAND.name]: DevelopmentIcon,
  [PropertyType.HOTEL.name]: LeisureIcon,
  [PropertyType.INDUSTRIAL.name]: IndustrialIcon,
  [PropertyType.MOTEL.name]: LeisureIcon,
  [PropertyType.OFFICE.name]: OfficeIcon,
  [PropertyType.RETAIL.name]: RetailIcon,
  [PropertyType.WAREHOUSE.name]: IndustrialIcon,
  [PropertyType.OTHER_COMMERCIAL.name]: BuildingIcon
};
export var BaseFeatures = _ref => {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'OTHER_COMMERCIAL' : _ref$type,
    props = _objectWithoutProperties(_ref, _excluded);
  var eer = props.eer && Number(props.eer);
  var renderFeatureIcon = (value, IconElem, title) => {
    if (value) {
      return ___EmotionJSX("span", {
        css: styles.feature
      }, ___EmotionJSX(IconElem, {
        size: "custom",
        css: styles.featureIcon,
        title: title
      }), ___EmotionJSX("span", {
        css: styles.featureValue
      }, value));
    }
    return null;
  };
  var isResi = props.listingType === ListingType.SALES_RESIDENTIAL.name || props.listingType === ListingType.RENTAL_RESIDENTIAL.name || props.listingType === ListingType.SHARE_RESIDENTIAL.name;
  var showEer = isResi && props.listingType !== ListingType.SHARE_RESIDENTIAL.name && !!eer && eer >= 0;
  var isCommercial = props.listingType === ListingType.SALES_COMMERCIAL.name || props.listingType === ListingType.RENTAL_COMMERCIAL.name;
  var displayPropertyType = (isResi || isCommercial) && (props.media.mobile && type.length <= 5 || !props.media.mobile);
  var hasTypeSeparator = Boolean(isResi && (props.beds || props.baths || props.parking || eer) || props.size && isCommercial);
  var PropertyTypeIcon = Icons[type.toUpperCase()] || DEFAULT_PROPERTY_ICON;
  return ___EmotionJSX("div", {
    css: styles.features
  }, isResi && ___EmotionJSX("div", {
    css: styles.featuresIcons
  }, renderFeatureIcon(props.beds, BedIcon, 'Bedrooms'), renderFeatureIcon(props.baths, BathIcon, 'Bathrooms'), renderFeatureIcon(props.parking, ParkingIcon, 'Parking'), showEer && renderFeatureIcon(eer.toFixed(1), EerIcon, 'EER')), props.size && props.size > 0 && isCommercial && ___EmotionJSX("div", {
    css: styles.size
  }, ___EmotionJSX(SizeIcon, null), ___EmotionJSX("span", {
    css: styles.sizeValue
  }, props.size, " m", ___EmotionJSX("span", {
    css: styles.sizeSuperscript
  }, "2"))), type && displayPropertyType && ___EmotionJSX("div", {
    css: styles.type
  }, isCommercial && ___EmotionJSX(PropertyTypeIcon, null), (isResi || isCommercial) && ___EmotionJSX("span", {
    css: /*#__PURE__*/_css([styles.typeValue, hasTypeSeparator && styles.separator])
  }, type)));
};
export var Features = withMedia(BaseFeatures);